module.exports = __webpack_public_path__ + "img/super-bundle-35.e35e4c6.webp";